import React, { useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonials, Testimonial } from '../data/content';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-183" data-mp="3fxuoa9d1ywuy">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-[18px] w-[18px] fill-vibrant-green text-vibrant-green" aria-hidden="true" data-id="element-184" data-mp="3ayqcdayqul0x" data-mpi={i} />)}
    </div>;
}
function Card({
  t
}: {
  t: Testimonial;
}) {
  return <article className="flex h-full flex-col rounded-2xl border border-sage/20 bg-white p-6 shadow-sm shadow-sage/5" data-id="element-185" data-mp="31yl6x6d41wpe">
      <Stars data-id="element-186" data-mp="2x2mmftuwkyu9" />
      <p className="mt-4 flex-1 text-sm leading-relaxed text-slate/80" data-id="element-187" data-mp="2s1yloggvh3mu">“{t.text}”</p>
      <div className="mt-6 flex items-center gap-3" data-id="element-188" data-mp="2s430htgb7n1w">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-189" data-mp="v8591v8ft91q">
          {t.initials}
        </span>
        <div data-id="element-190" data-mp="h5f0hpouu32s">
          <p className="text-sm font-bold text-slate" data-id="element-191" data-mp="h5oppb22s67f">{t.name}</p>
          <p className="text-xs text-slate/60" data-id="element-192" data-mp="m51cjvsy5da0">{t.city}</p>
          <p className="text-xs italic text-dark-green" data-id="element-193" data-mp="m6m91qytn6ai">{t.role}</p>
        </div>
      </div>
    </article>;
}
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: number) => {
    setIndex(prev => (prev + dir + testimonials.length) % testimonials.length);
  }, []);
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-194" data-mp="zyiw3glmuq01">
      <div className="mx-auto max-w-5xl" data-id="element-195" data-mp="14uhi4xjhnvxa">
        <div className="mx-auto max-w-2xl text-center" data-id="element-196" data-mp="14xdewijloek5">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-slate sm:text-4xl" data-id="element-197" data-mp="q5v18re7qw3y">
            Lo que dicen nutricionistas de toda LATAM
          </h2>
          <p className="mt-3 text-sm text-slate/70 sm:text-base" data-id="element-198" data-mp="1ius8lzgvz8hx">
            <span className="text-vibrant-green" data-id="element-199" data-mp="1ith3nwbpfup8">⭐⭐⭐⭐⭐</span> 4.9/5 · Más de 500 profesionales en 7
            países
          </p>
        </div>

        {/* Desktop grid */}
        <div className="mt-10 hidden gap-6 md:grid md:grid-cols-3" data-id="element-200" data-mp="1xhh7bz3bdhn9">
          {testimonials.map(t => <Card key={t.name} t={t} data-id="element-201" data-mp="1sk7fydwd6vws" />)}
        </div>

        {/* Mobile slider */}
        <div className="mt-10 md:hidden" data-id="element-202" data-mp="1og9jyc2c617y">
          <div className="relative overflow-hidden" data-id="element-203" data-mp="1ojf89p354z2m">
            <AnimatePresence mode="wait" data-id="element-204" data-mp="1jh6dqoamdoye">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-205" data-mp="1jkc221bfcmt2">
                <Card t={testimonials[index]} data-id="element-206" data-mp="10s9r96lgs0qq" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex items-center justify-between" data-id="element-207" data-mp="vrlvy8q7cxqp">
            <button onClick={() => go(-1)} aria-label="Testimonio anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-sage/30 text-dark-green" data-id="element-208" data-mp="qtu41epk5bmi">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-209" data-mp="37g0fnckq6m5x" />
            </button>

            <div className="flex gap-2" data-id="element-210" data-mp="37hto8xewfggk">
              {testimonials.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-sage' : 'w-2 bg-sage/30'}`} data-id="element-211" data-mp="3cfldtks2mqhl" data-mpi={i} />)}
            </div>

            <button onClick={() => go(1)} aria-label="Testimonio siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-sage/30 text-dark-green" data-id="element-212" data-mp="2jobiniwyl9in">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-213" data-mp="2spt65mcp4dhd" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}